import React from 'react';
import GameBoard from './game/GameBoard';
import './GamePage.css';

function GamePage() {
	return (
		<main className="game-page">
			<GameBoard />
		</main>
	);
}

export default GamePage;
